import { ComponentMap } from '@cinch-nx/data-storyblok'
import { FaqAccordion } from '@cinch-nx/landing-ui-shared'
import { sharedStoryblokComponents } from '@cinch-nx/storyblok'
import { WhyChoose } from '../../components'
import { Hero, NavigationButton } from '../components'

const localStoryblokComponents: ComponentMap = {
  FaqSection: FaqAccordion,
  GenericHero: Hero,
  WhyChooseSection: WhyChoose,
  Button: NavigationButton,
}

export const storyblokComponents: ComponentMap = {
  ...sharedStoryblokComponents,
  ...localStoryblokComponents,
}
